import { render, staticRenderFns } from "./emergencia.vue?vue&type=template&id=f668a59e&scoped=true"
import script from "./emergencia.vue?vue&type=script&lang=js"
export * from "./emergencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f668a59e",
  null
  
)

export default component.exports